"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderNav = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var HeaderNav = exports.HeaderNav = _styledComponents["default"].div.withConfig({
  displayName: "HeaderNav",
  componentId: "sc-1lmh14x-0"
})(["@media (max-width:", "){display:none;}@media (min-width:", "){margin-block:", " calc(-1 * ", ");}"], _encoreFoundation.screenXsMax, _encoreFoundation.screenSmMin, (0, _index.cssSpacing)('tighter-2', '8px'), (0, _index.cssSpacing)('looser', '20px'));